const SEED_NOTICES = [
  {
    id: 1,
    notice: 'All lecture sessions and test series will remain suspended on account of Ganesh Chaturthi festival. Rescheduled timetable will be posted on mobile app by tomorrow evening.',
    date: '2026-08-19',
    createdAt: '2026-08-19T09:00:00Z',
  },
  {
    id: 2,
    notice: 'Assessment Paper 1 (Principles and Practice of Accounting) will be conducted this Saturday from 10:00 AM to 01:00 PM across all branch centres.',
    date: '2026-08-18',
    createdAt: '2026-08-18T11:30:00Z',
  },
  {
    id: 3,
    notice: 'Parents are requested to clear the second term course tuition fee installments by 31st August 2026 to ensure uninterrupted mobile app study material access.',
    date: '2026-08-16',
    createdAt: '2026-08-16T14:00:00Z',
  },
  {
    id: 4,
    notice: 'Special physics mechanics and optics doubt clearance workshop with Dr. V. Raman scheduled for Sunday 02:00 PM at Dadar Main Campus auditorium.',
    date: '2026-08-15',
    createdAt: '2026-08-15T16:45:00Z',
  },
]

function getStoredNotices() {
  try {
    const raw = localStorage.getItem('cloud_notices_records')
    if (!raw) {
      localStorage.setItem('cloud_notices_records', JSON.stringify(SEED_NOTICES))
      return SEED_NOTICES
    }
    return JSON.parse(raw)
  } catch {
    return SEED_NOTICES
  }
}

function saveStoredNotices(list) {
  try {
    localStorage.setItem('cloud_notices_records', JSON.stringify(list))
    window.dispatchEvent(new Event('cloud-notices-updated'))
  } catch (err) {
    console.error('Failed to save notices to localStorage', err)
  }
}

export async function fetchNoticesList(searchText = '', sortBy = 'id', sortOrder = 'desc') {
  await new Promise((resolve) => setTimeout(resolve, 80))
  let list = getStoredNotices()

  if (searchText) {
    const q = searchText.toLowerCase().trim()
    list = list.filter((n) => (n.notice || '').toLowerCase().includes(q))
  }

  list.sort((a, b) => {
    let valA = a[sortBy] ?? ''
    let valB = b[sortBy] ?? ''
    if (sortBy === 'id') {
      return sortOrder === 'asc' ? a.id - b.id : b.id - a.id
    }
    if (typeof valA === 'string') {
      return sortOrder === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA)
    }
    return sortOrder === 'asc' ? valA - valB : valB - valA
  })

  return {
    records: list,
    totalRecords: list.length,
  }
}

export async function getNoticeById(id) {
  await new Promise((resolve) => setTimeout(resolve, 50))
  const list = getStoredNotices()
  const found = list.find((n) => n.id === parseInt(id, 10))
  if (!found) throw new Error(`Notice not found with ID ${id}`)
  return found
}

export async function createNotice(noticeText) {
  await new Promise((resolve) => setTimeout(resolve, 120))
  const list = getStoredNotices()

  const newRecord = {
    id: Date.now() + Math.floor(Math.random() * 1000),
    notice: noticeText || '',
    date: new Date().toISOString().split('T')[0],
    createdAt: new Date().toISOString(),
  }

  const updatedList = [newRecord, ...list]
  saveStoredNotices(updatedList)
  return newRecord
}

export async function updateNotice(id, noticeText) {
  await new Promise((resolve) => setTimeout(resolve, 100))
  const list = getStoredNotices()
  const targetId = parseInt(id, 10)

  const updatedList = list.map((item) => {
    if (item.id === targetId) {
      return {
        ...item,
        notice: noticeText,
        updatedAt: new Date().toISOString(),
      }
    }
    return item
  })

  saveStoredNotices(updatedList)
  return updatedList.find((n) => n.id === targetId)
}

export async function deleteNotice(id) {
  await new Promise((resolve) => setTimeout(resolve, 80))
  const list = getStoredNotices()
  const targetId = parseInt(id, 10)
  const filtered = list.filter((n) => n.id !== targetId)
  saveStoredNotices(filtered)
  return { success: true }
}
